module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modal-title": 'Edit Tag'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('FormulateForm', [_c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "Name",
      "validation": "required"
    },
    model: {
      value: (_vm.tagModel.name),
      callback: function($$v) {
        _vm.$set(_vm.tagModel, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "tagModel.name"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "textarea",
      "label": "Description"
    },
    model: {
      value: (_vm.tagModel.description),
      callback: function($$v) {
        _vm.$set(_vm.tagModel, "description", $$v)
      },
      expression: "tagModel.description"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ede9b7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/TagModal.vue
// module id = 652
// module chunks = 0